<template>
    <!-- component -->
    <!--  -->
    <div
        class="w-auto h-[319px] rounded-[15px] shadow-sm overflow-hidden bg-white flex justify-between"
    >
        <!--   <div class="relative">
             <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.899"
                height="14.899"
                viewBox="0 0 14.899 14.899"
                class="absolute right-3 top-3"
            >
                <g id="info_2_" data-name="info (2)" opacity="0.5">
                    <path
                        id="Path_25877"
                        data-name="Path 25877"
                        d="M7.45,0A7.45,7.45,0,1,0,14.9,7.45,7.45,7.45,0,0,0,7.45,0Zm0,13.658A6.208,6.208,0,1,1,13.658,7.45,6.208,6.208,0,0,1,7.45,13.658Z"
                        transform="translate(0 0)"
                    />
                    <path
                        id="Path_25878"
                        data-name="Path 25878"
                        d="M11.339,10h-.67a.67.67,0,1,0,0,1.339h.67v4.018a.67.67,0,0,0,1.339,0V11.339A1.339,1.339,0,0,0,11.339,10Z"
                        transform="translate(-3.89 -4.085)"
                    />
                    <ellipse
                        id="Ellipse_1216"
                        data-name="Ellipse 1216"
                        cx="1.005"
                        cy="1.005"
                        rx="1.005"
                        ry="1.005"
                        transform="translate(6.445 3.069)"
                    />
                </g>
            </svg> 
        </div>-->

        <div class="py-5 flex items-center flex-wrap w-full">
            <div class="p-2" v-if="data.icon == 'Impressions'">
                <img
                    src="../../../assets/Gif/ad-loops.gif"
                    class="w-[70px] h-[70px] md:w-[80px] md:h-[80px]"
                    alt=""
                />
            </div>
            <div class="p-2" v-if="data.icon == 'DistanceCovered'">
                <img
                    src="../../../assets/Gif/distance-covered.gif"
                    class="w-[70px] h-[70px] md:w-[80px] md:h-[80px]"
                />
            </div>
            <div class="w-auto mx-auto">
                <p class="mb-0 text-[16px] xl:text-[22px] font-bold text-black 0 capitalize">
                    {{ data.name }}
                </p>
                <p class="mb-0 text-[14px] xl:text-[28px] font-semibold text-primary">
                    {{ data.value }}
                </p>
                <p class="mb-0 text-[14px] xl:text-[16px] font-normal text-black 0 capitalize">
                    {{ data.info }}
                </p>
            </div>
        </div>
        <div class="mr-5 mt-5">
            <tool-tip
                v-if="data.icon == 'Impressions'"
                title="Ad Loop"
                discription="How many times your ad has been displayed."
            >
            </tool-tip
            ><tool-tip
                v-if="data.icon == 'DistanceCovered'"
                title="Distance Covered"
                discription="How many kilometers covered with your ad on."
            >
            </tool-tip>
        </div>
    </div>
    <!-- <div class="relative z-60">
        <tool-tip
            class="absolute right-6 bottom-28"
            title="Impressions"
            discription="The number of people with the highest probability of seeing your ad."
        >
        </tool-tip>
    </div> -->
</template>

<script>
import ToolTip from "../ToolTip.vue";
export default {
    components: { ToolTip },
    props: {
        data: {
            name: "",
            value: "",
            icon: "",
            info: "",
        },
    },
};
</script>

<style></style>
